export default "__VITE_ASSET__C32180AK__"